import { render, staticRenderFns } from "./seguro-empate-tooltip.vue?vue&type=template&id=99d73360&scoped=true&"
import script from "./seguro-empate-tooltip.vue?vue&type=script&lang=js&"
export * from "./seguro-empate-tooltip.vue?vue&type=script&lang=js&"
import style0 from "./seguro-empate-tooltip.vue?vue&type=style&index=0&id=99d73360&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d73360",
  null
  
)

export default component.exports